import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import "./style.scss";
import { MenuItem } from "../../@types/stores/menu";
import MenuItemBlock from "../../components/MenuItem";
import { useParams } from "react-router";
import menuStore from "../../stores/menu";
import Footer from "../../components/Footer";
import OrderIdle from "../../components/OrderIdle";

const MenuItemPage = () => {
    let params = useParams()

    const [item, setItem] = useState<MenuItem>();

    useEffect(() => {
        getItem(params.number);
    }, [params.number]);

    const getItem = async (number: string | undefined) => {
        if (!menuStore.menu) {
            await menuStore.getMenu();

            const category = params.category ? +params.category : 0;
            menuStore.changeCategory(category);

            const subCategory = params.subCategory ? +params.subCategory : 0;
            menuStore.changeSubCategory(subCategory);
        }

        if (number) {
            const _item = menuStore.getItemByNumber(number);
            if (_item) {
                setItem(_item);
                menuStore.changeMenuItem(_item.id);
            }
        }
    }

    return <div className="MenuItemPage">
        <Header />
        {item
            ? <MenuItemBlock item={item} menuId={+(params.category || 0)} subMenuId={+(params.subCategory || 0)} />
            : null
        }
        <Footer showBack={true} />
        <OrderIdle />
    </div>
}

export default MenuItemPage;